import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import BlockIcon from "@mui/icons-material/Block";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { Typography, Box } from "@mui/material";

export default function OpenClosed({ hours, dayFilterOn }) {
    const [showTimes, setShowTimes] = useState(false);
    const daysOfWeek = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
    ];
    const [sortedOpenTimes, setSortedOpenTimes] = useState({});
    const [todayHours, setTodayHours] = useState([]);
    const [status, setStatus] = useState();
    const isSameOrAfter = require("dayjs/plugin/isSameOrAfter");
    dayjs.extend(isSameOrAfter);

    useEffect(() => {
        function sortOpenTimes(openTimes) {
            const daysOfWeek = [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
            ];
            let sortedOpenTimes = {};

            for (let i = 0; i < 7; i++) {
                for (const key in openTimes) {
                    if (daysOfWeek[i] === key) {
                        sortedOpenTimes[key] = openTimes[key].map((e) =>
                            dayjs(e)
                        );
                    }
                }
            }

            return sortedOpenTimes;
        }
        if (hours !== undefined) {
            const times = sortOpenTimes(hours);
            setSortedOpenTimes(times);
        }
    }, [hours]);

    useEffect(() => {
        const daysOfWeek = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
        ];

        function getStatus() {
            const now = dayjs(`2025-01-${dayjs().day() + 5}T${dayjs().format("HH:mm:ss")}`)
            const todayHours = sortedOpenTimes[daysOfWeek[now.day()]];
            if (todayHours === "Closed") return { status: "closedToday" };
            if (todayHours.length === 0) return { status: "closedToday" };


            for (let i = 0; i < todayHours.length; i += 2) {
                if (now.isBetween(todayHours[i], todayHours[i + 1])) {
                    return { status: "openNow", hours: `${todayHours[i + 1].format('h:mm A')}` };
                }
            }

            let index = -1;
            let min = 86400;
            for (let i = 0; i < todayHours.length; i += 2) {
                if(todayHours[i].isSameOrAfter(now))
                {
                    if(todayHours[i].diff(now, "second") < min) {
                        min = todayHours[i].diff(now, "second");
                        index = i;
                    }
                }
            }
            if(index !== -1) {
                return { status: "closedNow", hours: todayHours[index].format('h:mm A')};
            }
            return {status: 'closedToday'};
        }
        if (Object.keys(sortedOpenTimes).length !== 0) {
            const { status, hours: todayHours } = getStatus();
            setStatus(status);
            setTodayHours(todayHours);
        }
    }, [sortedOpenTimes]);


    const isBetween = require("dayjs/plugin/isBetween");
    dayjs.extend(isBetween);

    return (
        <div>
            {!dayFilterOn ? (
                status === "openNow" ? (
                    <div className="flex flex-row mt-2 items-center ml-2 gap-2 text-[#009000]">
                        <CheckCircleOutlineIcon />
                        <p>Open now (Closes: {todayHours})</p>
                    </div>
                ) : status === "closedNow" ? (
                    <div className="flex flex-row items-center ml-2 mt-2 gap-2 text-yellow-600">
                        <BlockIcon />
                        <p>Closed now (Opens: {todayHours})</p>
                    </div>
                ) : (
                    <div className="flex flex-row items-center ml-2 mt-2 gap-2 text-red-500">
                        <BlockIcon />
                        <p>Closed today</p>
                    </div>
                )
            ) : (
                null
            )}
            <div
                className="flex flex-row gap-2 items-center cursor-pointer transition-all duration-300 p-2 rounded-lg"
                onClick={() => setShowTimes(!showTimes)}
            >

                <div className="flex flex-row items-center gap-2">
                    <AccessTimeIcon />
                    <p>See times</p>
                </div>
                <button className="flex items-center px-1 py-1 bg-button_grey text-black rounded-full shadow-md hover:bg-hover_button_grey transition">
                    <KeyboardArrowDownIcon
                        className={`w-2 h-2 transform transition-transform duration-300 ${
                            showTimes ? "rotate-180" : "rotate-0"
                        }`}
                    />
                </button>
            </div>

            <Box
                className={`flex flex-col gap-1 text-left p-2 ml-3 mt-2 transition-all duration-500 overflow-hidden ${
                    showTimes ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                }`}
            >
                {Object.entries(sortedOpenTimes).map(
                    ([day, timeArray], index) => {
                        if (timeArray.length === 0) {
                            return (
                                <Box key={index} class="flex justify-between">
                                    <Typography sx={{mt:.5}}>{daysOfWeek[index]}</Typography>
                                    <Typography sx={{mt:.5}}>{"Closed"}</Typography>
                                </Box>
                            );
                        } else
                            return (
                                <Box key={index} class="flex justify-between">
                                    <Typography sx={{mt:.5}} variant="h7">{daysOfWeek[index]}</Typography>
                                    <Box sx={{mt:.5}}>
                                        {timeArray.map((time, i) => {
                                            if (i % 2 === 0)
                                                return (
                                                    <Typography
                                                        variant="h7"
                                                        key={i}
                                                        className="text-sm transition-opacity duration-500"
                                                    >
                                                    <span
                                                        key={index + i * 2}
                                                        className="font-semibold"
                                                    >
                                                        {"   "}
                                                    </span>{" "}
                                                        {`${timeArray[i].format(
                                                            "h:mm A"
                                                        )} - ${timeArray[
                                                        i + 1
                                                            ].format("h:mm A")}`}
                                                    </Typography>
                                                );
                                            else return null;
                                        })}
                                    </Box>
                                </Box>
                            );
                    }
                )}
            </Box>
        </div>
    );
}